module.exports = __webpack_public_path__ + "img/bttn_purple_pin.dcf6f7ef.png";